export default "__VITE_ASSET__6bff4bca__"